import React, { useRef,useState , useEffect} from "react";
import { useDrag, useDrop } from "react-dnd";
import SearchableSelect from "util/component/SearchableSelect";
import SearchableSelectAsync from "util/component/SearchableSelect/async";
import SearchableSelectAsyncUnit from "util/component/SearchableSelect/asyncUnit";
import CustomTextAreaList from "./CustomTextAreaList";

import { useDispatch } from "react-redux";

const DND_ITEM_TYPE = "row";
const TRIANGLE_RED = "rgb(248 79 49)";
const TRIANGLE_GREEN = "rgb(35 197 82)";
const TRIANGLE_GRAY = "rgb(235 230 230)";

const critical = [
    {
        descr: "Critical",
        label: "Critical",
        value: "Critical",
    },
    {
        descr: "Key",
        label: "Key",
        value: "Key",
    },
    {
        descr: "Non-key",
        label: "Non-key",
        value: "Non-key",
    },
    {
        descr: "N/A",
        label: "N/A",
        value: "N/A",
    },
];

const mainalter = [
    {
        label: "Main",
        value: "Main",
    },
    {
        label: "Alter",
        value: "Alter",
    },
];

const options = {
    mainalter: mainalter,
    critical: critical,
};

const min_unit = [
    { value: "≥", label: "≥" },
    { value: ">", label: ">" },
];
const max_unit = [
    { value: "≤", label: "≤" },
    { value: "<", label: "<" },
];

const CustomTextArea = ({ data, changed, checkHide, readOnly, customStyle = {}, children }) => {
    const dispatch = useDispatch();

    const _onFocus = (e) => {
        try {
            e.target.closest('td').classList.add('tdFocused')
            //e.target.classList.add()
            dispatch({ type: "FOCUS_TD", td: e.target });
        } catch (e) {}
    };
    const _onBlur = (e) => {
        e.target.closest('td').classList.remove('tdFocused')
        dispatch({ type: "BLUR_TD" });
        changed(e);
    };

    return (
        <div
            contentEditable={checkHide?.value !== "TRUE" && !readOnly}
            className={`editableDiv`}
            suppressContentEditableWarning={true}
            onFocus={_onFocus}
            onBlur={_onBlur}
            style={{ ...customStyle, color: readOnly ? "#AAA" : "#000" }}
        >
            {data.value}
        </div>
    );
};



const Rows = (props) => {
    const {
        api,
        code,
        rowData,
        index,
        moveRow,
        moveEnd = () => {},
        changed,
        deleted,
        PROCode = null,
        copied = () => {},
        dispatch = () => {},
        copyRev = () => {},
        copySndToRcv = () => {},
        onOpen,
        RevCmptCheckList,
        qcGroup = [],
        tableType,
        remarkList,
        setRemarkList,
        changeRemark,
        textValue,
        setTextValue,
        updateRemarkListRow= () => {},
        SetQCGroup,
        FindQCGroup= () => {},
        removeClass,
    } = props;

    
    const dropRef = useRef(null);
    const dragRef = useRef(null);
    const [, drop] = useDrop({
        type: DND_ITEM_TYPE,
        accept: DND_ITEM_TYPE,
        hover(item, monitor) {
            if (!dropRef.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            // Determine rectangle on screen
            const hoverBoundingRect = dropRef.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            // Time to actually perform the action
            moveRow(code, dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex;
        },
        drop: moveEnd,
    });

    const [{ isDragging }, drag, preview] = useDrag({
        item: { index },
        type: DND_ITEM_TYPE,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0 : 1;

    preview(drop(dropRef));
    drag(dragRef);
    let remarkCnt = 0;
    let remark = rowData?.find((search) => {
        remarkCnt++;
        return search.name === "remark";
    });
    const remark_chk = remark?.value !== "FALSE";

    const checkHide = rowData?.find((search) => {
        return search.name === "hide";
    });

    const blurCheck = (e, value, required) => {
        e.target.closest('td').classList.remove('tdFocused')
        if (!!!value && !!required) {
            e.target.closest("td").classList.add("invalid");
        }
    };


    const focusCheck = (e) => {

        e.target.closest('td').classList.add('tdFocused')
        e.target.closest("td").classList.remove("invalid");
    };


    let selectData="";
    const focusDivRef = useRef(null);
    const [remarkOpen, SetRemarkOpen] = useState(false);
    const [qcGroupOpen, SetQcGroupOpen] = useState(false);
    const _onFocus = (e) => {
        //setTextValue(e.target.innerHTML);
        e.target.closest('td').classList.add('tdFocused');
        selectData="";
        SetRemarkOpen(!remarkOpen);

        try {
            dispatch({ type: "FOCUS_TD", td: e.target });
        } catch (e) {}
    };

    const remarkState = (e) => {
        //setTextValue(e.target.innerHTML);
        selectData="";
        SetRemarkOpen(!remarkOpen);

    };
    const qcGroupState = (e) => {
        //setTextValue(e.target.innerHTML);
        selectData="";
        SetQcGroupOpen(!qcGroupOpen);

    };
    const addClass = (e) =>{
        e.target.closest('td').classList.add('tdFocused');
    }
    const uniqueCode = rowData.find((data) => data?.name === "uniqueCode")?.value;
    const interfaceCode = rowData.find((data) => data?.name === "interfaceCode")?.value;
    const sheetReview =
        RevCmptCheckList !== undefined ? RevCmptCheckList.filter((sheet) => sheet.uniqueCode === uniqueCode) : undefined;

    let revRowData = [];
    const search = new URLSearchParams(window.location.search);
    let tmpYn = search.get("tempYn") || "N";
    let unitNum = 0;

    rowData.forEach((data, i) => {
        const celNm = sheetReview !== undefined ? sheetReview.find((v) => (data.name === "unit2" && data.revCelNm === v.celNm) || (data.name !== "unit2" && data.name === v.celNm)) : undefined;
        if (uniqueCode) {
            if (celNm !== undefined) {
                data = {
                    ...data,
                    cmptCheck: true,
                    cmptType: celNm.cmptType === "R" ? TRIANGLE_RED : TRIANGLE_GREEN,
                };
            } else if (tmpYn === "N") {
                data = { ...data, cmptCheck: false };
            } else if (tmpYn === "Y" && data.name === "paraCd") {
                data = { ...data, cmptCheck: false };
            } else {
                data = { ...data, cmptCheck: true, cmptType: TRIANGLE_GRAY };
            }

            if (data.name === "unit1") {
                data = { ...data, cmptCheck: false };
            }
        }

        revRowData = [...revRowData, ...[data]];
    });

    return (
        <>
            <tr
                rowSpan={remark_chk ? "2" : "1"}
                ref={dropRef}
                style={{ opacity }}
                className={checkHide?.value === "TRUE" ? "isDisabled" : ""}
            >
                <td rowSpan={remark_chk ? "2" : "1"} ref={dragRef}>
                    {index + 1}
                </td>
                {revRowData.map((vv, ii) => {
                    const _key = code + index + "" + ii;
                    if (vv.type === "checkbox") {
                        return (
                            <td key={_key}>
                                <input
                                    type="checkbox"
                                    name={vv.name}
                                    checked={vv.value !== "FALSE"}
                                    onChange={(e) => {
                                        if (vv.name === "hide") {
                                            changed(code, index, ii, {
                                                value: e.target.checked ? "" : "FALSE",
                                                check: vv.name,
                                            });
                                        } else {
                                            if (checkHide?.value !== "TRUE") {
                                                changed(code, index, ii, {
                                                    value: e.target.checked ? "" : "FALSE",
                                                    check: vv.name,
                                                });
                                            }
                                        }
                                    }}
                                />
                            </td>
                        );
                    } else if (vv.type === "select") {
                        if (vv.options === "main") {

                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style= {interfaceCode ?{ position: "relative",backgroundColor: "rgba(0, 0, 0, 0.067)"}: { position: "relative" }   }
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelectAsync
                                        api={api}
                                        body={{ macd: PROCode, disableYn: "N" }}
                                        search={true}
                                        onChange={(val) => {
                                            // console.log(val);
                                            changed(code, index, ii, {
                                                value: val.value,
                                                other: val,
                                                // isUnit: false
                                            });
                                            changed(code, index, unitNum, { value: "", isUnit: false });   
                                        }}
                                        value={vv.value}
                                        isTable={true}
                                        name={vv.name}
                                        textAlign={"left"}
                                        isDisabled={checkHide?.value === "TRUE" || interfaceCode}
                                    />
                                </td>
                            );
                        } else if (vv.options === "unit") {
                            unitNum = ii;
                            const unitOpt = rowData.find((f) => f.name === "paraCd");
                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelectAsyncUnit
                                        api={"/pcsCreate/retrieveUnitList"}
                                        body={{ pacd: unitOpt?.value, disableYn: "N" }}
                                        search={false}
                                        onChange={(val) => {
                                            changed(code, index, ii, { value: val.value, isUnit: true });
                                        }}
                                        value={vv.value}
                                        isTable={true}
                                        name={vv.name}
                                        placeholderTextAlign={"right"}
                                        placeholder={"▼"}
                                        isDisabled={checkHide?.value === "TRUE"}
                                        textAlign={"center"}
                                    />
                                </td>
                            );
                        } else if (vv.options === "sample") {
                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelectAsync
                                        api={"/common/retrieveSamplePointList"}
                                        body={{
                                            grcd: document.getElementById("processCd").value,
                                            disableYn: "N",
                                        }}
                                        search={true}
                                        onChange={(val) => {
                                            changed(code, index, ii, {
                                                value: val.value,
                                                label: val.label,
                                                sample: "true",
                                            });
                                        }}
                                        value={vv.value}
                                        label={vv.label}
                                        isTable={true}
                                        name={vv.name}
                                        textAlign="left"
                                        isDisabled={checkHide?.value === "TRUE"}
                                    />
                                </td>
                            );
                        } else if (vv.options === "qcGroup") {  
                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelect
                                        options={qcGroup}
                                        search={false}
                                        onChange={(val) => {
                                            changed(code, index, ii, { value: val.value });
                                        }}
                                        value={vv.value}
                                        name={vv.name}
                                        isTable={true}
                                        textAlign="left"
                                        placeholderTextAlign="right"
                                        isDisabled={checkHide?.value === "TRUE"}
                                        textWrap={true}
                                    />
                                </td>
                            );
                        } else if (vv.options === "sign") {
                            let opt = [{ value: "", label: "　" }];
                            switch(vv.opttype) {
                                case "all": opt = [...opt, ...min_unit, ...max_unit]; break;
                                case "min": opt = [...opt, ...min_unit]; break;
                                case "max": opt = [...opt, ...max_unit]; break;
                                default: opt = [...opt]
                            }
                            return (
                                <td
                                    key={_key}
                                    className={!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    <SearchableSelect
                                        options={opt}
                                        search={false}
                                        onChange={(val) => {
                                            changed(code, index, ii, { value: val.value });
                                        }}
                                        value={vv.value}
                                        isTable2={true}
                                        name={vv.name}
                                        textAlign="center"
                                        placeholderTextAlign="center"
                                        isDisabled={checkHide?.value === "TRUE"}
                                    />
                                </td>
                            );
                        } else if (vv.options === "qcoption") {
                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelectAsync
                                        api={"/common/retrieveOptionList"}
                                        body={{
                                            grcd: document.getElementById("processCd").value,
                                            disableYn: "N",
                                        }}
                                        search={true}
                                        onChange={(val) => {
                                            changed(code, index, ii, {
                                                value: val.value,
                                                label: val.label,
                                            });
                                        }}
                                        placeholder={""}
                                        value={vv.value}
                                        label={vv.label}
                                        isTable={true}
                                        name={vv.name}
                                        textAlign="left"
                                        isDisabled={checkHide?.value === "TRUE"}
                                    />
                                </td>
                            );
                        } else if(vv.options === "critical") {
                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelectAsync
                                        api={"/common/retrieveMasterCodeList"}
                                        body={{
                                            grcd: "CRI",
                                            disableYn: "N",
                                        }}
                                        search={true}
                                        onChange={(val) => {
                                            changed(code, index, ii, {
                                                value: val.value,
                                                label: val.label,
                                            });
                                        }}
                                        placeholder={""}
                                        value={vv.value}
                                        label={vv.label}
                                        isTable={true}
                                        name={vv.name}
                                        textAlign="center"
                                        isDisabled={checkHide?.value === "TRUE"}
                                    />
                                </td>
                            );
                        }else {
                            return (
                                <td
                                    key={_key}
                                    className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                    data-reviewdata={`${uniqueCode}${vv.name}`}
                                    onBlur={(e) => {
                                        blurCheck(e, vv.value,vv.required);
                                    }}
                                    onFocus={(e) => {
                                        focusCheck(e);
                                    }}
                                    style={{ position: "relative" }}
                                >
                                    {vv.cmptCheck ? (
                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "10",
                                                    cursor: "pointer",
                                                    position: "absolute",
                                                    backgroundColor: vv.cmptType,
                                                    top: 0,
                                                    right: 0,
                                                    width: 20,
                                                    height: 20,
                                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                }}
                                                onClick={() => onOpen(vv, uniqueCode)}
                                            ></div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <SearchableSelect
                                        options={options[vv.options]}
                                        search={true}
                                        onChange={(val) => {
                                            changed(code, index, ii, { value: val.value });
                                        }}
                                        value={vv.value}
                                        isTable={true}
                                        name={vv.name}
                                        textAlign="left"
                                        placeholderTextAlign="right"
                                        isDisabled={checkHide?.value === "TRUE"}
                                    />
                                </td>
                            );
                        }
                    } else if (vv.type === "text") {
                        if (vv.name !== "remark" )
                            if (vv.options === "qcGroup"){
                                return (
                                    <td
                                        key={_key}
                                        className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                        data-reviewdata={`${uniqueCode}${vv.name}`}
                                        onBlur={(e) => {
                                            blurCheck(e, vv.value, vv.required);
                                        }}
                                        onFocus={(e) => {
                                            focusCheck(e);
                                        }}
                                        style={{ position: "relative", ...vv.borderStyle }}
                                    >
                                        {vv.cmptCheck && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        zIndex: 10,
                                                        cursor: "pointer",
                                                        position: "absolute",
                                                        backgroundColor: vv.cmptType,
                                                        top: 0,
                                                        right: 0,
                                                        width: 20,
                                                        height: 20,
                                                        transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                    }}
                                                    onClick={() => onOpen(vv, uniqueCode)}
                                                ></div>
                                            </div>
                                        )}
                                        {vv.name === 'dayCycle' && vv.value === 'ZZ' ?
                                            <div
                                                style={{padding: 0, fontSize: "0.7rem"}}
                                            >
                                                {vv?.value}
                                            </div>
                                            :
                                            <div
                                                className={`editableDiv`}
                                                suppressContentEditableWarning={true}
                                                onClick={(e)=>{SetQcGroupOpen(!qcGroupOpen); addClass(e)}}
                                                // onBlur={_onBlur}
                                                //style={{...customStyle, color: readOnly ? "#AAA" : "#000"}}
                                                ref={focusDivRef}
                                                //onInput={_onChange}
                                                onChange={(e) => {
                                                    changed(code, index, remarkCnt - 1, {value: e.target.innerText.toString().trim(),});
                                                    updateRemarkListRow(uniqueCode, e.target.innerText.toString().trim(), tableType);
                                                }}
                                            >
                                                {vv.value}
                                            </div>
                                        }
                                        {qcGroupOpen &&
                                            <CustomTextAreaList
                                                changed={(e) => {
                                                    changed(code, index, ii, {
                                                        value: e.target.innerText.toString().trim(),
                                                    });
                                                    FindQCGroup();
                                                }}
                                                optionChanged={(value) => {
                                                    changed(code, index, ii, {
                                                        value: value,
                                                    });
                                                    FindQCGroup();
                                                }}
                                                changeData={
                                                    (uniqueCode, value,oldValue) => {
                                                        changeRemark(uniqueCode, value, "sampleDesc",oldValue);
                                                        FindQCGroup();
                                                    }}
                                                dataList={qcGroup}
                                                updateListRow={FindQCGroup}
                                                setDataList={SetQCGroup}
                                                openState={()=>{qcGroupState();removeClass('tdFocused');}}
                                                textValue={textValue}
                                                setTextValue={setTextValue}
                                            />
                                        }
                                        {/* </div> */}
                                    </td>
                                )
                            } else {
                                return (
                                    <td
                                        key={_key}
                                        className={!!!vv.value && !!vv.required ? "invalid" : ""}
                                        data-reviewdata={`${uniqueCode}${vv.name}`}
                                        onBlur={(e) => {
                                            blurCheck(e, vv.value, vv.required);
                                        }}
                                        onFocus={(e) => {
                                            focusCheck(e);
                                        }}
                                        style={{ position: "relative", ...vv.borderStyle }}
                                    >
                                        {vv.cmptCheck && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        zIndex: 10,
                                                        cursor: "pointer",
                                                        position: "absolute",
                                                        backgroundColor: vv.cmptType,
                                                        top: 0,
                                                        right: 0,
                                                        width: 20,
                                                        height: 20,
                                                        transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                                    }}
                                                    onClick={() => onOpen(vv, uniqueCode)}
                                                ></div>
                                            </div>
                                        )}
                                         {vv.name === 'dayCycle' && vv.value === 'ZZ'  ?
                                            <div
                                                style={{ padding: 0, fontSize: "0.7rem" }}
                                            >
                                                {vv?.value}
                                            </div>
                                            :
                                            <CustomTextArea
                                                data={vv}
                                                changed={(e) => {
                                                    changed(code, index, ii, {
                                                        value: e.target.innerText.toString().trim(),
                                                    });
                                                }}
                                                customStyle={{
                                                    ...vv.style,
                                                    position: "relative",
                                                    inset: 0,
                                                    overflow: "hidden",
                                                }}
                                                checkHide={checkHide}
                                                readOnly={vv.readOnly}
                                            >
                                                {/*                                        <div style={{cursor:"pointer",position: "absolute", backgroundColor: vv.cmptType, top: 0, right: 0, width: 20, height: 20, transform: "translateX(10px) translateY(-10px) rotateZ(45deg)"}}
                                                    onClick={() =>onOpen(vv,uniqueCode)}></div>*/}
                                            </CustomTextArea>
                                        }
                                        {/* </div> */}
                                    </td>
                                )
                            }
                    } else if (vv.type === "button") {
                        return (
                            <td
                                key={_key}
                                // className={!!vv.value ? "" : "invalid"}
                                // onBlur={(e) => { blurCheck(e, vv.value) }}
                                // onFocus={(e) => { focusCheck(e) }}
                                // style={}
                                style={{ padding: 0, fontSize: "0.5rem" }}
                            >
                                {/* <div style={{ alignItems: "center" }}> */}
                                <button
                                    style={{
                                        border: "none",
                                        cursor: "pointer",
                                        backgroundColor: "transparent",
                                        fontSize: "inherit",
                                    }}
                                    onClick={() => copyRev(code, index)}
                                    disabled={checkHide?.value === "TRUE"}
                                >
                                    {/* <FontAwesomeIcon icon={faClone} /> */}
                                    {'-->'}
                                </button>
                                <br/>
                                copy
                                <br/>
                                <button
                                    style={{
                                        border: "none",
                                        cursor: "pointer",
                                        backgroundColor: "transparent",
                                        fontSize: "inherit",
                                    }}
                                    onClick={() => copySndToRcv(code, index)}
                                    disabled={checkHide?.value === "TRUE"}
                                >
                                    {/* <FontAwesomeIcon icon={faClone} /> */}
                                    {'<--'}
                                </button>
                                {/* </div> */}
                            </td>
                        );
                    } else {
                        if (vv.type === "hidden") return null;
                        return (
                            <td key={_key} className={vv.type} data-reviewdata={`${uniqueCode}${vv.name}`}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textAlign: "center",
                                    }}
                                >
                                    {vv.value}
                                </div>
                            </td>
                        );
                    }
                })}
                <td className="delete-row" style={{ backgroundColor: "#FFF" }}>
                    <div className="deleteBox" onClick={() => deleted(code, index)}>
                        {/* <FontAwesomeIcon
                            onClick={() => {
                                deleted(code, index);
                            }}
                            icon={faDeleteLeft}
                        /> */}
                        del
                    </div>
                    <div className="copyBox" onClick={() => copied(code, index)}>
                        {/* <FontAwesomeIcon
                            onClick={() => {
                                copied(code, index);
                            }}
                            icon={faClone}
                        /> */}
                        copy
                    </div>
                </td>
            </tr>
            <tr className={(remark_chk ? "" : "d-none") + " " + (checkHide?.value === "TRUE" ? "isDisabled" : "")}>
                <td colSpan={rowData.filter((f) => f.type !== "hidden" || f.type2 !== 'hidden').length}
                    data-reviewdata={`${uniqueCode}${"remark"}`}>
                    {revRowData.find((f) => f.name === "remark")?.cmptCheck && (
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    zIndex: 10,
                                    cursor: "pointer",
                                    position: "absolute",
                                    backgroundColor: revRowData.find((f) => f.name === "remark")?.cmptType,
                                    top: 0,
                                    right: 0,
                                    width: 20,
                                    height: 20,
                                    transform: "translateX(10px) translateY(-10px) rotateZ(45deg)",
                                }}
                                onClick={() =>
                                    onOpen(
                                        revRowData.find((f) => f.name === "remark"),
                                        uniqueCode
                                    )
                                }
                            ></div>
                        </div>
                    )}
                    <div>
                        <div

                            className={`editableDiv`}
                            suppressContentEditableWarning={true}
                            onClick={(e)=>_onFocus(e)}
                           // onBlur={_onBlur}
                            //style={{...customStyle, color: readOnly ? "#AAA" : "#000"}}
                            ref={focusDivRef}
                            //onInput={_onChange}
                            onChange={(e) => {
                                changed(code, index, remarkCnt - 1, {value: e.target.innerText.toString().trim(),});
                                updateRemarkListRow(uniqueCode, e.target.innerText.toString().trim(), tableType);
                            }}
                        >
                            {remark.value}
                        </div>

                        {remarkOpen &&
                            <CustomTextAreaList
                                data={remark}
                                changed={(e) => {
                                    changed(code, index, remarkCnt - 1, {
                                        value: e.target.innerText.toString().trim(),
                                    });
                                    updateRemarkListRow(uniqueCode, e.target.innerText.toString().trim(), tableType);
                                }}
                                optionChanged={(value) => {
                                    changed(code, index, remarkCnt - 1, {
                                        value: value,
                                    });
                                    updateRemarkListRow(uniqueCode, value, tableType);
                                }}
                                changeData={
                                    (uniqueCode, value,oldValue) => {
                                        changeRemark(uniqueCode, value, "remark",oldValue);
                                        //updateRemarkListRow(uniqueCode,value.value,tableType);
                                    }}
                                dataList={remarkList}
                                updateListRow={updateRemarkListRow}
                                setDataList={setRemarkList}
                                openState={()=>{remarkState();removeClass('tdFocused');}}
                                textValue={textValue}
                                setTextValue={setTextValue}
                            />
                        }
                    </div>
                </td>
            </tr>
        </>
);
};

const areEquals = (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next);
};

export default React.memo(Rows, areEquals);